import React, { useEffect, useState, useContext } from "react";
import Modal from "@mui/material/Modal";
import Grid from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import { useSnackbar } from "notistack";
import { AuthContext } from "../../context/AuthContext";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import AdapterJalaali from "@date-io/jalaali";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const FinishDate = (props) => {
  const status = props.status;
  const endDate = props.endDate;
  const processEndDate = props.processEndDate;
  const orderId = props.orderId;
  //   console.log(props.processEndDate);
  const auth = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const [isLoading, setIsLoading] = useState(false);
  const [finishDate, setFinishDate] = useState(
    status == 1 ? new Date(Number(processEndDate)) : new Date(Number(endDate))
  );

  //getting the route it came from
  const prevRoute = useSelector((state) => state.routeReducer.prevRoute);
  const navigate = useNavigate();

  const submitHandler = () => {
    console.log(prevRoute);
    navigate(prevRoute);
  };

  //handle finish
  const finishHandler = () => {
    setIsLoading(true);
    axios
      .post(
        "/api/v1/laboratorys/update-order-toFinish",
        {
          orderId: Number(orderId),
          endDate: new Date(finishDate).getTime(),
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: auth.token,
          },
        }
      )
      .then((response) => {
        enqueueSnackbar(response.data.message.message, {
          variant: "success",
        });
        setIsLoading(false);
        handleClose();
        navigate(prevRoute);
      })
      .catch((e) => {
        const messages =
          e.response.data.data.length > 0
            ? e.response.data.data
            : e.response.data.message.message;
        setIsLoading(false);
        Array.isArray(messages)
          ? messages.map((message) => {
              enqueueSnackbar(message, { variant: "error" });
            })
          : enqueueSnackbar(messages, { variant: "error" });
      });
  };

  //handle unfinish
  const unfinishHandler = () => {
    setIsLoading(true);
    axios
      .put(
        "/api/v1/laboratorys/update-order-toDoctor",
        {
          orderId: Number(orderId),
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: auth.token,
          },
        }
      )
      .then((response) => {
        enqueueSnackbar(response.data.message.message, {
          variant: "success",
        });
        setIsLoading(false);
        handleClose();
        navigate(prevRoute);
      })
      .catch((e) => {
        const messages = e.response.data.data;
        setIsLoading(false);
        Array.isArray(messages)
          ? messages.map((message) => {
              enqueueSnackbar(message, { variant: "error" });
            })
          : enqueueSnackbar(messages, { variant: "error" });
      });
  };

  return (
    <>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Typography variant="h6" component="h2">
            هشدار
          </Typography>
          {status == 2 ? (
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              آیا مطمئنید که می خواهید این سفارش را باز گردانید ؟
            </Typography>
          ) : (
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              آیا مطمئنید که می خواهید این سفارش را مختومه کنید ؟
            </Typography>
          )}
          <Grid container spacing={3} sx={{ mt: 2 }}>
            <Grid xs={6}>
              <Button
                fullWidth
                color="error"
                variant="contained"
                onClick={status == 2 ? unfinishHandler : finishHandler}
              >
                بله
              </Button>
            </Grid>
            <Grid xs={6}>
              <Button
                fullWidth
                color="primary"
                variant="contained"
                onClick={handleClose}
              >
                خیر
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>

      <Grid
        container
        spacing={2}
        sx={{ my: 2, py: 2, borderTop: 1, borderBottom: 1 }}
      >
        <Grid md={12} xs={12}>
          <Typography variant="h5" align="center" sx={{ mb: 2 }}>
            تغییر وضعیت
          </Typography>
        </Grid>
        <Grid md={8} xs={12}>
          <FormControl fullWidth>
            <LocalizationProvider dateAdapter={AdapterJalaali}>
              <DatePicker
                value={finishDate}
                onChange={(date) => setFinishDate(date)}
                label={status == 1 ? "تاریخ جهت اتمام" : "تاریخ اتمام"}
                disableMaskedInput
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    size={"medium"}
                    variant={"outlined"}
                  />
                )}
                disabled={status == 2}
              />
            </LocalizationProvider>
          </FormControl>
        </Grid>
        <Grid md={4} xs={12}>
          <Button
            fullWidth
            color="warning"
            variant="contained"
            sx={{ height: "100%" }}
            onClick={handleOpen}
          >
            {status == 1 ? " اتمام کار" : " بازگشت کار"}
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default FinishDate;
